var _defs, _circle, _path, _circle2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect, _path9, _path10, _rect2, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomAipackage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 50 50",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .cls-1 {\r\n                fill: #231f20;\r\n            }\r\n\r\n            .cls-2 {\r\n                fill: #00a1d3;\r\n            }\r\n\r\n            .cls-3 {\r\n                fill: #d12200;\r\n            }\r\n\r\n            .cls-4 {\r\n                fill: #ffba50;\r\n            }\r\n\r\n            .cls-5 {\r\n                fill: #8d7f89;\r\n            }\r\n        "))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 25.784,
    cy: 38.411,
    r: 0.502
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.325,37.909a.5.5,0,1,0,.5.5A.5.5,0,0,0,28.325,37.909Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 30.819,
    cy: 38.411,
    r: 0.502
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.382,34.892a3.513,3.513,0,0,0-1.736.463v-3.5a.5.5,0,0,0-.5-.5H13.625a.5.5,0,0,0-.339.867,2.51,2.51,0,0,1,.825,1.861,2.538,2.538,0,0,1-5.076,0,2.51,2.51,0,0,1,.825-1.861.5.5,0,0,0-.339-.867H5a.5.5,0,0,0-.5.5V43A2.5,2.5,0,0,0,7,45.5H18.146a.5.5,0,0,0,.5-.5v-3.5a3.535,3.535,0,1,0,1.736-6.613Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M20.382,40.968a2.505,2.505,0,0,1-1.866-.833.506.506,0,0,0-.55-.129.5.5,0,0,0-.32.466V44.5H7A1.5,1.5,0,0,1,5.5,43V32.357H8.489a3.472,3.472,0,0,0-.454,1.728,3.538,3.538,0,0,0,7.076,0,3.472,3.472,0,0,0-.454-1.728h2.989v4.03a.5.5,0,0,0,.32.467.506.506,0,0,0,.55-.129,2.505,2.505,0,0,1,1.866-.833,2.538,2.538,0,1,1,0,5.076Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45,31.357H41.506a3.476,3.476,0,0,0,.459-1.736,3.538,3.538,0,0,0-7.076,0,3.476,3.476,0,0,0,.459,1.736H31.854a.5.5,0,0,0-.5.5v4.521a.5.5,0,0,0,.867.339,2.509,2.509,0,0,1,1.86-.825,2.538,2.538,0,1,1,0,5.076,2.509,2.509,0,0,1-1.86-.825.5.5,0,0,0-.867.339V45a.5.5,0,0,0,.5.5H43A2.5,2.5,0,0,0,45.5,43V31.857A.5.5,0,0,0,45,31.357Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M44.5,43A1.5,1.5,0,0,1,43,44.5H32.354v-2.99a3.472,3.472,0,0,0,1.727.455,3.538,3.538,0,1,0,0-7.076,3.482,3.482,0,0,0-1.727.454V32.357h4.03a.5.5,0,0,0,.338-.869,2.507,2.507,0,0,1-.833-1.867,2.538,2.538,0,0,1,5.076,0,2.507,2.507,0,0,1-.833,1.867.5.5,0,0,0,.337.869H44.5Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.909,23.752a3.647,3.647,0,0,1,1.046-2.406,6.815,6.815,0,0,0-.618-9.949,6.856,6.856,0,0,0-5.7-1.423,6.819,6.819,0,0,0-3.592,11.37,3.658,3.658,0,0,1,1.048,2.408,1.256,1.256,0,0,0-1.111,1.237v.929a1.272,1.272,0,0,0,1.27,1.27h.1a3.668,3.668,0,0,0,7.308,0h.1a1.272,1.272,0,0,0,1.27-1.27v-.929A1.256,1.256,0,0,0,28.909,23.752Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M19.27,15.611a5.776,5.776,0,0,1,4.556-4.656A5.873,5.873,0,0,1,28.7,12.168a5.815,5.815,0,0,1,.528,8.49,4.641,4.641,0,0,0-1.317,3.061H26.868V19.39h.363A1.367,1.367,0,0,0,28.6,18.026V17.9a1.364,1.364,0,1,0-2.728,0v.491H24.132V17.9a1.364,1.364,0,1,0-2.728,0v.127a1.367,1.367,0,0,0,1.365,1.364h.363v4.329H22.088a4.65,4.65,0,0,0-1.318-3.063A5.806,5.806,0,0,1,19.27,15.611Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M23.132,18.39h-.363a.364.364,0,0,1-.365-.364V17.9a.364.364,0,1,1,.728,0Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    height: 4.33,
    width: 1.736,
    x: 24.132,
    y: 19.39
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M26.868,18.39V17.9a.364.364,0,1,1,.728,0v.127a.364.364,0,0,1-.365.364Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M25,29.537a2.683,2.683,0,0,1-2.654-2.349h5.308A2.683,2.683,0,0,1,25,29.537Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    height: 1.468,
    rx: 0.27,
    width: 8.039,
    x: 20.98,
    y: 24.719
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25,9.021a.5.5,0,0,0,.5-.5V5a.5.5,0,0,0-1,0V8.521A.5.5,0,0,0,25,9.021Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33.011,17.032a.5.5,0,0,0,.5.5h3.524a.5.5,0,0,0,0-1H33.511A.5.5,0,0,0,33.011,17.032Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.965,17.532h3.524a.5.5,0,0,0,0-1H12.965a.5.5,0,0,0,0,1Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.312,9.911a.5.5,0,0,0,.682.183.5.5,0,0,0,.183-.683L19.415,6.359a.5.5,0,1,0-.865.5Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.371,13.277a.5.5,0,0,0,.25-.067l3.052-1.762a.5.5,0,0,0-.5-.867l-3.052,1.763a.5.5,0,0,0,.25.933Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.379,20.854l-3.052,1.762a.5.5,0,1,0,.5.867l3.052-1.763a.5.5,0,1,0-.5-.866Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.327,11.448l3.052,1.762a.5.5,0,1,0,.5-.866l-3.052-1.763a.5.5,0,0,0-.5.867Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.121,21.72l3.052,1.763a.5.5,0,0,0,.25.067.5.5,0,0,0,.25-.934l-3.052-1.762a.5.5,0,1,0-.5.866Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.006,10.094a.5.5,0,0,0,.682-.183L31.45,6.859a.5.5,0,1,0-.865-.5L28.823,9.411A.5.5,0,0,0,29.006,10.094Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomAipackage);
export default __webpack_public_path__ + "static/media/custom-aipackage.aa04ea6a80cf0d840782e4d56d8ef1bf.svg";
export { ForwardRef as ReactComponent };